import React, { Component } from 'react'
import styled from 'styled-components';
import arrowNext from '../../../assets/images/icon/arrow-next.png';
import arrowPrev from '../../../assets/images/icon/arrow-prev.png';
import arrowStart from '../../../assets/images/icon/arrow-start.png';
import arrowEnd from '../../../assets/images/icon/arrow-end.png';

class PaginationButtons extends Component {
  constructor(props) {
    super(props);
    this.maxVisiblePages = 5;
  }

  handlePageChange = (newPage) => {
    const { totalPageCount, onChangePage } = this.props;
    if (newPage >= 1 && newPage <= totalPageCount) {
      onChangePage(newPage);
    }
  };

  render() {
    const { currentPage, totalPageCount } = this.props;
    const maxVisiblePages = this.maxVisiblePages;

    const currentGroup = Math.ceil(currentPage / maxVisiblePages);
    const startPage = (currentGroup - 1) * maxVisiblePages + 1;
    let endPage = startPage + maxVisiblePages - 1;

    if (endPage > totalPageCount) {
      endPage = totalPageCount;
    }

    return (
      <Container>
        <PageButton
          onClick={() => this.handlePageChange(1)}
          disabled={currentPage === 1}
          img={arrowStart}
        />
        <PageButton
          onClick={() => this.handlePageChange(startPage - 1)}
          disabled={startPage === 1}
          img={arrowPrev}
        />
        
        {Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index).map(page => (
          <PageButton
            key={page}
            isActive={currentPage === page}
            onClick={() => this.handlePageChange(page)}
          >
            {page}
          </PageButton>
        ))}

        <PageButton
          onClick={() => this.handlePageChange(startPage + maxVisiblePages)}
          disabled={endPage === totalPageCount}
          img={arrowNext}
        />
        <PageButton
          onClick={() => this.handlePageChange(totalPageCount)}
          disabled={currentPage === totalPageCount}
          img={arrowEnd}
        />
      </Container>
    );
  }
}

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  height: 32px;
  margin-top: 16px;
`;

const PageButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: none;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;

  ${({ img }) => img ? `
    background-image: url(${img});
    background-size: 32px 32px;
    background-repeat: no-repeat;
  ` : ``}

  ${({ isActive }) => isActive ? `
    background-color: var(--primary-500) !important;
    color: var(--grey-900) !important;
  ` : `
    background-color: white;
    color: black;
  `}

  &:hover {
    background-color: rgba(239, 239, 252, 1);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export default PaginationButtons;
